import React from "react";
import { View } from "react-native";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { DropDownProps } from "./types";
import { colors } from "../../../theme";
import { ErrorHelperText } from "../TextInput";

const styles = (hasError: boolean) => ({
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: hasError ? colors.red : colors.sky.dark,
    borderRadius: "8px",
    borderWidth: hasError ? "2px" : "1px",
  },
});

const SelectDisplayProps = { style: { paddingTop: 13.5, paddingBottom: 13.5 } };

export default function DropdownWeb({ list, value, setValue, error, label }: DropDownProps) {
  const hasError = !!error?.message;

  return (
    <View className="pt-1.5">
      <FormControl fullWidth error={hasError}>
        <InputLabel>{label}</InputLabel>
        <Select
          onChange={(event) => setValue(event?.target?.value)}
          sx={styles(hasError)}
          {...{
            value,
            label,
            SelectDisplayProps,
          }}
        >
          {list.map(({ label, value }, idx) => (
            <MenuItem key={idx} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
        {hasError && <ErrorHelperText error={error}>{error?.message}</ErrorHelperText>}
      </FormControl>
    </View>
  );
}
